<template>
  <div v-if="showDialog" class="editable-dialog">
    
    <div class="header" draggable="true" @dragend="drag">
      <h4>{{ $t(header) || $t("dialogBox") }}</h4>
    </div>

    <b-nav class="tab" tabs>
      <b-nav-item class="node-tab node-element" @click="changeTab" active>{{$t('element')}}</b-nav-item>
      <b-nav-item class="node-tab node-visible" @click="changeTab" >{{$t('visibility')}}</b-nav-item>
      <b-nav-item class="node-tab node-properties" @click="changeTab" >{{$t('properties')}}</b-nav-item>
      <b-nav-item class="node-tab node-equations" @click="changeTab" >{{$t('equations')}}</b-nav-item>
    </b-nav>

    <div class="visible" v-if="tabVisible == 2">
      <label>{{$t('conditionsOfVisibility')}} </label>
      <b-input class="input-pentagro" v-model="expression" type="text"></b-input>

      <!-- BOTÕES -->
      <b-button-group class="m-2">
        <b-button 
          @click="select(0)" 
          :class="{'btn-success': buttonSelected.current }">
          {{$t('currents')}}
        </b-button>
        <b-button 
          @click="select(1)" 
          :class="{'btn-success': buttonSelected.operation }">
          {{$t('operations')}}
        </b-button>
      </b-button-group>
      <!-- /BOTÕES -->

      <!-- CORRENTE -->
      <div v-if="buttonSelected.current" class="pt-2">

        <label for="select-current">{{$t('selectACurrent')}}</label>
        <select 
          id="select-current" 
          class="form-control" 
          @change="changeCurrent()" 
          v-model="form.current"> 
            <option value="" selected>{{$t('chooseACurrent')}}</option>
            <option v-for="(current, index) in currents"
              :key="`node-current-${index}`" :value="current">
                {{current}}
            </option>
        </select>

        <div v-if="form.current" class="pt-2">
          <select 
            id="select-properties" 
            class="form-control" 
            @change="changeCurrentProperties()" 
            v-model="form.prop">
              <option value="" selected>{{$t('chooseAProperty')}}</option>
              <option v-for="(prop, index) in currentProperties"
                :key="`node-prop-${index}`" :value="prop">
                  {{ prop.name }}
              </option>
          </select> 
        </div>
      </div>

      <div v-if="false">
        <label for="select-component">{{$t('selectAComponent')}}</label>
      </div>
      <!--/CORRENTE -->

      <!-- OPERATIONS -->
      <div v-if="buttonSelected.operation" class="pt-2">
        <label for="select-operation">{{$t('operations')}}</label>
        <select class="form-control" id="select-operation" @change="changeOperation()" v-model="form.operation"> 
            <option value="" selected>{{$t('chooseAOperation')}}</option>
            <option v-for="(operation, index) in operations"
              :key="index" :value="operation">
                {{operation}}
            </option>
        </select>                      
      </div>
      <!-- /OPERATIONS -->

      <!-- ATRIBUTOS -->
      <div 
        v-if="form.prop || form.operation" 
        class="pt-2 node-attr">
        <b-form-select 
          id="select-attr" 
          class="form-control input-pentagro" 
          v-model="attrSelected"> 
            <b-form-select-option value="" selected>{{$t('chooseAAtribute')}}</b-form-select-option>
            <b-form-select-option v-for="([key, value], index) in attrsMap.entries()"
              :key="`node-attr-${index}`" :value="[key, value.value]">
                {{`${value.key}: ${formatNumber(value.value)}`}}
            </b-form-select-option>
        </b-form-select>
        <b-icon 
          class="btn-icon"
          icon="plus-circle-fill" 
          @click="addParam(form.attr)" 
          aria-hidden="true" />
      </div>

      <!-- /ATRIBUTOS -->
    </div>
    <div class="body" v-if="tabVisible == 1">
      <FormAreaJoker v-if="node.type == types.AreaJoker" :node.sync="nodeEdited" />
      <FormInputCana v-if="node.type == types.InputCana" :importONLS=importData :node.sync="nodeEdited" />
      <FormInput v-if="node.type == types.Input" :node.sync="nodeEdited" />
      <FormOccupation v-if="node.type == types.Occupation" :node.sync="nodeEdited" />
      <FormCurrent v-if="node.type == types.Current" :node.sync="nodeEdited" />
      <FormText v-if="node.type == types.Text" :node.sync="nodeEdited" />
      <FormTriangle v-if="node.type == types.Triangle" :node.sync="nodeEdited" />
      <FormConnection v-if="node.type == types.Connection || node.type == types.Line" :node.sync="nodeEdited" />
      <FormRectangle v-if="node.type == types.Rectangle" :node.sync="nodeEdited" />
      <FormMilling v-if="node.type == types.Milling" :node.sync="nodeEdited" />
      <FormBoiler v-if="node.type == types.Boiler" :node.sync="nodeEdited" />
      <FormBomb v-if="node.type == types.Bomb" :node.sync="nodeEdited" />
      <FormContinuousDorna v-if="node.type == types.ContinuousDorna" :node.sync="nodeEdited" />
      <FormFermentationBatch v-if="node.type == types.FermentationBatch" :node.sync="nodeEdited" />
      <FormDistillationColumn2 v-if="node.type == types.DistillationColumn2" :node.sync="nodeEdited" />
      <FormDistillationColumnA v-if="node.type == types.DistillationColumnA" :node.sync="nodeEdited" />
      <FormDistillationColumnB v-if="node.type == types.DistillationColumnB" :node.sync="nodeEdited" />
      <FormSugarCooker v-if="node.type == types.SugarCooker" :node.sync="nodeEdited" />
      <FormSugarCookerContinuous v-if="node.type == types.SugarCookerContinuous" :node.sync="nodeEdited" />
      <FormCargoLoss v-if="node.type == types.CargoLoss" :node.sync="nodeEdited" />
      <FormVat v-if="node.type == types.Vat" :node.sync="nodeEdited" />
      <FormEthanolCentrifuge v-if="node.type == types.EthanolCentrifuge" :node.sync="nodeEdited" />
      <FormEvaporator v-if="node.type == types.Evaporator" :node.sync="nodeEdited" />
      <FormEvaporator2 v-if="node.type == types.Evaporator2" :node.sync="nodeEdited" />
      <FormDecanter v-if="node.type == types.Decanter" :node.sync="nodeEdited" />
      <FormDesuperheater v-if="node.type == types.Desuperheater" :node.sync="nodeEdited" />
      <FormFlotador v-if="node.type == types.Flotador" :node.sync="nodeEdited" />
      <FormDeaerator v-if="node.type == types.Deaerator" :node.sync="nodeEdited" />
      <FormEnergyDemand v-if="node.type == types.EnergyDemand" :node.sync="nodeEdited" />
      <FormTurbine v-if="node.type == types.Turbine" :node.sync="nodeEdited" />
      <FormFilter3 v-if="node.type == types.Filter3" :node.sync="nodeEdited" />
      <FormFilterPress v-if="node.type == types.FilterPress" :node.sync="nodeEdited" />
      <FormDiffuser v-if="node.type == types.Diffuser" :node.sync="nodeEdited" />
      <FormRegeneratorD v-if="node.type == types.RegeneratorD" :node.sync="nodeEdited" />
      <FormCoolingTower v-if="node.type == types.CoolingTower" :node.sync="nodeEdited" />
      <FormSprayDryer v-if="node.type == types.SprayDryer" :node.sync="nodeEdited" />
      <FormSugarCentrifugue v-if="node.type == types.SugarCentrifugue" :node.sync="nodeEdited" />
      <FormMultipleInput v-if="node.type == types.MultipleInput" :node.sync="nodeEdited" />
      <FormHeater v-if="node.type == types.Heater" :node.sync="nodeEdited" />
      <FormEvaporativeCondenser v-if="node.type == types.EvaporativeCondenser" :node.sync="nodeEdited" />
      <FormLiming v-if="node.type == types.Liming" :node.sync="nodeEdited" />
      <FormDryer v-if="node.type == types.Dryer" :node.sync="nodeEdited" />
      <FormArrow v-if="node.type == types.Arrow" :node.sync="nodeEdited" />
      <FormStrainer v-if="node.type == types.Strainer" :node.sync="nodeEdited" />
      <FormProductionChangeEditable v-if="node.type == types.ProductionChangeEditable" :node.sync="nodeEdited" />
      <FormTanque v-if="node.type == types.Tanque" :node.sync="nodeEdited" />
      <FormCondenser v-if="node.type == types.Condenser" :node.sync="nodeEdited" />
      <FormSugarCentrifugueBatch v-if="node.type == types.SugarCentrifugueBatch" :node.sync="nodeEdited" />
      <FormDilutionTank v-if="node.type == types.DilutionTank" :node.sync="nodeEdited" />
      <FormConcentratorYeast v-if="node.type == types.ConcentratorYeast" :node.sync="nodeEdited" />
      <FormFinisher v-if="node.type == types.Finisher" :node.sync="nodeEdited" />
      <FormWasher v-if="node.type == types.Washer" :node.sync="nodeEdited" />
      <FormCentrifugeCitrus v-if="node.type == types.CentrifugeCitrus" :node.sync="nodeEdited" />
      <FormCellFactory v-if="node.type == types.CellFactory" :node.sync="nodeEdited" />
      <FormEvaporationCitrus v-if="node.type == types.EvaporationCitrus" :node.sync="nodeEdited" />
      <FormExtractorCitrus v-if="node.type == types.ExtractorCitrus" :node.sync="nodeEdited" />
      <FormScrubber v-if="node.type == types.Scrubber" :node.sync="nodeEdited" />
      <FormInputCorn v-if="node.type == types.InputCorn" :node.sync="nodeEdited" :importONLS=importDataCorn />
      <FormInputCitrus v-if="node.type == types.Citrus" :node.sync="nodeEdited" :importONLS=importDataCitrus />
    </div>
    <div class="properties" v-if="tabVisible == 3">
      <div class="prop-node">
        <span>
          <label for="width">{{$t('lenghtPx')}} </label>
          <input id="width" v-model.number="nodeEdited.width" type="number">
        </span>
        <span>
          <label for="height">{{$t('heightPx')}} </label>
          <input id="height" v-model.number="nodeEdited.height" type="number">
        </span>
      </div>
    </div>

    <div class="equations" v-if="tabVisible == 4">
      <form-equation :nodeEdited="nodeEdited"></form-equation>
    </div>
    
    <div class="footer">
    
      <img
        v-if="node.type == types.InputCana ||node.type == types.InputCorn || node.type == types.Citrus"
        class="float-right"
        src="@/assets/importar.png"
        style="margin: 0 8px 0 10px;  width: 30px; cursor: pointer"
        :title="$t('importDataFromOnline')"
        alt="Importar dados do online"
        @click="importDataCane(node.type)"
      />
      
      <b-button @click="closeDialog" variant="danger">{{$t('cancel')}}</b-button>
      <b-button @click="saveNode" variant="success">{{$t('accept')}}</b-button>
    </div>

  </div>
</template>

<script>
import FormEquation from "./dialogForm/FormEquation.vue";
import FormAreaJoker from "./nodes/areaJoker/FormAreaJoker";
import FormInputCana from "./nodes/inputCana/FormInputCana";
import FormInput from "./nodes/input/FormInput";
import FormCurrent from "./nodes/current/FormCurrent";
import FormText from "./dialogForm/FormText"
import FormTriangle from "./nodes/triangle/FormTriangle"
import FormConnection from "./dialogForm/FormConnection"
import FormRectangle from "./dialogForm/FormRectangle"
import FormOccupation from "./nodes/ocupation/FormOccupation"
import FormBoiler from "./nodes/boiler/FormBoiler.vue"
import FormContinuousDorna from "./nodes/continuousDorna/FormContinuousDorna";
import FormFermentationBatch from "./nodes/FermentationBatch/FormFermentationBatch.vue"
import FormDistillationColumn2 from "./nodes/distillationColumn2/FormDistillationColumn2"
import FormDistillationColumnA from "./nodes/distillationColumnA/FormDistillationColumnA"
import FormDistillationColumnB  from "./nodes/distillationColumnB/DistillationColumnB"
import FormSugarCooker from "./nodes/sugarCooker/FormSugarCooker"
import FormSugarCookerContinuous from "./nodes/sugarCookerContinuous/FormSugarCookerContinuous.vue"
import FormCargoLoss from "./nodes/cargoLoss/FormCargoLoss.vue"
import FormVat from "./nodes/vat/FormVat.vue"
import FormEthanolCentrifuge from "./nodes/ethanolCentrifuge/FormEthanolCentrifuge"
import FormDecanter from "./nodes/decanter/FormDecanter"
import FormDesuperheater from "./nodes/desuperheater/FormDesuperheater"
import FormFlotador from "./nodes/flotador/FormFlotador"
import FormDeaerator from "./nodes/deaerator/FormDeaerator.vue"
import FormEnergyDemand from "./nodes/energyDemand/FormEnergyDemand"
import FormTurbine from "./nodes/turbine/FormTurbine"
import FormFilter3 from "./nodes/filter3/FormFilter3"
import FormFilterPress from "./nodes/filterPress/FormFilterPress"
import FormDiffuser from "./nodes/diffuser/FormDiffuser"
import FormRegeneratorD from "./nodes/regeneratorD/FormRegeneratorD"
import FormMilling from "./nodes/milling/FormMilling2"
import FormCoolingTower from "./nodes/coolingTower/FormCoolingTower"
import FormEvaporator from "./nodes/evaporator/FormEvaporator.vue"
import FormEvaporator2 from "./nodes/evaporator2/FormEvaporator2.vue"
import FormSprayDryer from './nodes/sprayDryer/FormSprayDryer'
import FormMultipleInput from "./nodes/multipleInput/FormMultipleInput";
import FormBomb from "./nodes/bomb/FormBomb.vue";
import FormEvaporativeCondenser from "./nodes/evaporativeCondenser/FormEvaporativeCondenser";
import FormSugarCentrifugue from "./nodes/sugarCentrifugue/FormSugarCentrifugue";
import FormSugarCentrifugueBatch from "./nodes/sugarCentrifugueBatch/FormSugarCentrifugueBatch";
import FormHeater  from "./nodes/heater/FormHeater"
import FormLiming from "./nodes/liming/FormLiming";
import FormDryer from "./nodes/dryer/FormDryer";
import FormArrow from "./nodes/arrow/FormArrow.vue";
import FormProductionChangeEditable from "./nodes/productionChangeEditable/FormProductionChangeEditable.vue";
import FormStrainer from "./nodes/strainer/FormStrainer.vue";
import FormTanque from "./nodes/tanque/FormTanque.vue";
import FormCondenser from "./nodes/condenser/FormCondenser";
import FormDilutionTank from "./nodes/dilutionTank/FormDilutionTank";
import FormConcentratorYeast from "./nodes/concentratorYeast/FormConcentratorYeast";
import FormInputCorn from "./nodes/inputCorn/FormInputCorn.vue";
import FormInputCitrus from "./nodes/citrus/FormCitrus.vue";
import { Types } from "./utils/nodeTypes"
import { SingletonEnginnering } from "./nodes/_service/singletonEngineering"
import { SingletonAreas } from "./nodes/_service/singletonAreas"
import { NumberFormat, ParseToNumber } from "../flowchart/utils/tools"
import { DragMixin } from "../mixins/dragMixin"
import { emitEventBuss } from '../../global';
import { urlMainAPI, showError } from "@/global";
import { SingletonFlowchart } from "./nodes/_service/singletonFlowchart";
import axios from 'axios'

  export default {
    name: "Dialog",

    provide() {
      return {
        cancelForm: this.closeDialog,
        saveForm: this.saveNode
      }
    },

    components: { 
      FormEquation, 
      FormAreaJoker, 
      FormInputCana, 
      FormInput, 
      FormCurrent,
      FormText,
      FormTriangle,
      FormConnection,
      FormRectangle,
      FormOccupation,
      FormBoiler,
      FormContinuousDorna,
      FormFermentationBatch,
      FormDistillationColumn2,
      FormDistillationColumnA,
      FormDistillationColumnB,
      FormSugarCooker,
      FormSugarCookerContinuous,
      FormCargoLoss,
      FormVat,
      FormEthanolCentrifuge,
      FormDecanter,
      FormDesuperheater,
      FormFlotador,
      FormDeaerator,
      FormEnergyDemand,
      FormTurbine,
      FormFilter3,
      FormFilterPress,
      FormDiffuser,
      FormRegeneratorD,
      FormMilling,
      FormCoolingTower,
      FormEvaporator,
      FormSprayDryer,
      FormEvaporator2,
      FormMultipleInput,
      FormBomb,
      FormEvaporativeCondenser,
      FormSugarCentrifugue,
      FormSugarCentrifugueBatch,
      FormHeater,
      FormLiming,
      FormDryer,
      FormArrow,
      FormStrainer,
      FormProductionChangeEditable,
      FormTanque,
      FormCondenser,
      FormDilutionTank,
      FormConcentratorYeast,
      FormInputCorn,
      FormInputCitrus
    },
    mixins: [ DragMixin ],
    props: {
      node: {
      type: Object,
      default: null
      },
      dialogVisible: {
        type: Number,
        default: 0
      }
    },

    data() {
      return {
        formatNumber: NumberFormat,
        types: new Types(),
        header: "",
        showDialog: false,
        nodeEdited: null,
        importData: 0,
        importDataCorn: 0,
        importDataCitrus: 0,
        tabVisible: 1,
        currents: [],
        operations: [],
        buttonSelected: {current: false, operation: false},
        currentProperties: "",
        attrsSelected: "",
        attrSelected: "",
        attrsMap: null,
        expression: null,
        form: {
          current: '',
          operation: '',
          prop: '',
          title: '',
          titleWidth: 0,
          titleHeight: 0,
          titleFontSize: 0,
        },
        attrName: "",
        attrsForVisible: new Map(),
      }
    },

    watch:{
      dialogVisible(){
        this.header = this.types.Caption[this.node.type];
        console.log(`Editar:`, this.node);

        if (this.node && typeof this.node.applyEquationResults === "function") {
          try {
            this.node.applyEquationResults();
          } catch (e) {
            console.warn("Falha ao recalcular equacoes do nodo:", e);
          }
        }

        this.nodeEdited = this.node.clone(); 
        if(!this.nodeEdited.attrs || !this.nodeEdited.attrs.length){
          this.nodeEdited.attrs = this.nodeEdited.data.map(d => d.clone ? d.clone() : { ...d })
        }

        this.expression = this.node.expressionVisible
        this.currents = SingletonEnginnering.currents,
        this.operations = SingletonEnginnering.operations,
        
        this.showDialog = true;

        setTimeout(this.resizeDialog, 150)
      }
    },

    methods: {
      finalize() {
        this.showDialog = false;
        this.tabVisible = 1;
        document.querySelector(".node-visible>a").classList.add('active')
      },

      async saveNode() {
        if (this.nodeEdited.idName.includes("Citrus")) 
        {
          let data = this.nodeEdited.attrs;

          let sumProp_mp1 = 0;
          let sumProp_mp2 = 0;
          let sumProp_mp3 = 0;
          let sumPropT1 = 0;
          let sumPropT2 = 0;
          let sumPropT3 = 0;

          let shouldPass = true;

          let type1 = 'T1';
          let type2 = 'T2';
          let type3 = 'T3';

          data.forEach(item => {
            if (item.mapping.includes('tipo_produto')) 
            {
              //NFC
              if (ParseToNumber(NumberFormat(item.value)) == 1 && type1 == 'T1') 
              {
                type1 = item.index  
              }
              //FCOJ
              if (ParseToNumber(NumberFormat(item.value)) == 2 && type2 == 'T2') 
              {
                type2 = item.index  
              }
              //RFA
              if (ParseToNumber(NumberFormat(item.value)) == 3 && type3 == 'T3') 
              {
                type3 = item.index  
              }
            }
          });
          
          data.forEach(item => {
            if (item.mapping.includes('fm_mp1') && (item.mapping.includes(type1))) 
            {
              sumProp_mp1 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp2') && (item.mapping.includes(type1))) 
            {
              sumProp_mp2 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp3') && (item.mapping.includes(type1))) 
            {
              sumProp_mp3 = ParseToNumber(NumberFormat(item.value));
            }
          });

          sumPropT1 = sumProp_mp1 + sumProp_mp2 + sumProp_mp3

          data.forEach(item => {
            if (item.mapping.includes('fm_mp1') && (item.mapping.includes(type2))) 
            {
              sumProp_mp1 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp2') && (item.mapping.includes(type2))) 
            {
              sumProp_mp2 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp3') && (item.mapping.includes(type2))) 
            {
              sumProp_mp3 = ParseToNumber(NumberFormat(item.value));
            }
          });

          sumPropT2 = sumProp_mp1 + sumProp_mp2 + sumProp_mp3 

          data.forEach(item => {
            if (item.mapping.includes('fm_mp1') && (item.mapping.includes(type3))) 
            {
              sumProp_mp1 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp2') && (item.mapping.includes(type3))) 
            {
              sumProp_mp2 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp3') && (item.mapping.includes(type3))) 
            {
              sumProp_mp3 = ParseToNumber(NumberFormat(item.value));
            }
          });

          sumPropT3 = sumProp_mp1 + sumProp_mp2 + sumProp_mp3 

          let sumNFC = (sumPropT1 > 99 && sumPropT1 < 101) ? true : false;
          let sumFCOJ = (sumPropT2 > 99 && sumPropT2 < 101) ? true : false;
          let sumRFA = (sumPropT3 > 99 && sumPropT3 < 101) ? true : false;
          
          if (!sumNFC && sumPropT1 != 0)
          {
            showError(this.$t('naoatingiu-100-prop-nfc'))
            shouldPass = false;
          }

          if (!sumFCOJ && sumPropT2 != 0)
          {
            showError(this.$t('naoatingiu-100-prop-fcoj'))
            shouldPass = false;
          }

          if (!sumRFA && sumPropT3 != 0)
          {
            showError(this.$t('naoatingiu-100-prop-rfa'))
            shouldPass = false;
          } 
          
          if (shouldPass) 
          {
            
            this.node.applyProperties(this.nodeEdited);
            this.node.update(this.nodeEdited);
            this.nodeEdited.data = this.node.data
            this.node.expressionVisible = this.expression
            SingletonAreas.SaveJoker(this.nodeEdited);
            SingletonAreas.SaveStatus();
            this.finalize()
            
            this.saveCurrentFlowchart();
          }
        } else 
        {
          this.node.applyProperties(this.nodeEdited);
          this.node.update(this.nodeEdited);
          this.nodeEdited.data = this.node.data
          this.node.expressionVisible = this.expression
          SingletonAreas.SaveJoker(this.nodeEdited);
          SingletonAreas.SaveStatus();
          this.finalize()
        }
      },

      async saveCurrentFlowchart() {
        let nodes = SingletonFlowchart.Memory.getNodesToSave();
        let width = document.querySelector("#canvas").clientWidth
        let transform = document.querySelector('#board').getAttribute('transform')

        let flowchart = {
          id: 0,
          area: SingletonAreas.currentArea,
          configuration: JSON.stringify(nodes),
          transform: transform + ` width(${width})`,
          type: 'PAP'
        };

        if (this.saveFlowchart(flowchart)) {
          SingletonFlowchart.wasModified = false;
        }
      },

      async saveFlowchart(flowchart) {
        let success = false;
        const url = `${urlMainAPI}/saveflowchart/PAP`;

        await axios.post(url, flowchart)
          .then((res) => {
            if (res.status == 200)
              flowchart.id = res.data.id
            success = true;
            SingletonAreas.UpdateArea(flowchart)
          })
          .catch(e => console.log(e));

        return success;
      },

      closeDialog(){
        this.finalize()
      },

      configDragble(){
        this.classToDrag = ".editable-dialog";
        this.fixMouseY = -120
        this.limitTop= -100
        this.limitBotom= 0
        this.limitRight= 0
        this.limitLeft= 0
      },

      executeSimulation(){
        emitEventBuss("ExecuteSimulation", null)
      },

      importDataCane(typesFunc) 
      {
        if (typesFunc == this.types.Citrus) 
        {
          this.importDataCitrus ++ 
        }
        if (typesFunc == this.types.InputCorn) 
        {
          this.importDataCorn ++ 
        } else 
        {
          this.importData ++ 
        }
      },

      changeTab(event){
        document.querySelectorAll(".node-tab>a").forEach(el => el.classList.remove('active'))
        
        let result = event.target.innerText;

        if(result == "Equações"){
          this.tabVisible = 4
          document.querySelector(".node-equations>a").classList.add('active')
        }
        else if(result == "Propriedades"){
          this.tabVisible = 3
          document.querySelector(".node-properties>a").classList.add('active')
        }
        else if(result == "Visibilidade"){
          this.tabVisible = 2
          document.querySelector(".node-visible>a").classList.add('active')
        }
        else {
          this.tabVisible = 1
          document.querySelector(".node-element>a").classList.add('active')
        }
      },

      clearInfo(){
        this.form.current = ""
        this.form.operation = ""
        this.form.prop = ""
        this.form.attr = ""
      },

      select(indice){
        Object.keys(this.buttonSelected).forEach((show, i) => { this.buttonSelected[show] = i == indice })
        this.clearInfo()
      },

      changeCurrent(){
        let props = SingletonEnginnering.getCurrentProperties(this.form.current);
        this.currentProperties = props
        this.form.prop = ""
        this.form.attr = ""
      },

      changeCurrentProperties(){
        let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.form.current, this.form.prop);
        this.attrsSelected = attrs;
        this.attrName = `${(this.form.prop.name == "Atributos" ? 'cr' : 'cp')}|${this.form.current}|${this.form.prop.name}|`
        this.attrsMap = new Map()
        attrs.forEach(e => this.attrsMap.set(e.key, e))
      },

      changeOperation(){
        this.attrName = "op|" + this.form.operation + "|"
        let attrs = SingletonEnginnering.getOperationsProperties(this.form.operation);
        this.attrsSelected = attrs
        this.attrsMap = new Map()
        attrs.forEach(e => this.attrsMap.set(e.key, e))
      },

      addParam(){
        let [attr, value] = [...this.attrSelected]
        this.attrName += attr
        this.expression += this.attrName
        this.attrsForVisible.set(this.attrName, value)
        this.clearInfo()
      },

      resizeDialog(){
        let el = document.querySelector(".editable-dialog")
        if(el){
          el.style.display = "grid";
          el.style.left = `calc(50% - ${(el.clientWidth / 2)}px)`
          el.style.top = `calc(50% - ${(el.clientHeight / 2)}px)`
          el.style['transition-duration'] = "100ms";
        }
      },
    },
    mounted() {
      this.configDragble();
      this.$nextTick(function () {
          this.$refs.input && this.$refs.input.focus();
      });
    },
    destroyed(){
    }
  }
</script>

<style scoped>
.editable-dialog {
  display: none;

  position: absolute;
  top: calc(50% -150px);
  left: calc(50% - 150px);
  min-width: 300px;
  background-color: #fff;

  border-radius: 7px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  font-size: 0.9rem;
  z-index: 10;
}

h2 {
  padding: 0;
  margin: 0;
}
.header {
  display: flex;
  justify-content: flex-start;
  padding: 8px;
  border-bottom: 1px solid #0005;
  color: #0008;
  cursor: all-scroll;
}

.tab{
  margin: 5px 5px 0px 2px;
}

.tab a{
  color: #0007;
  background-color: #00000008;
  height: 25px;
  padding: 2px 2px 2px 2px;
}

.visible{
  width: 100%;
  padding: 8px;
}

.node-attr{
  display: flex;
  align-items: center;
}

.prop-node{
  display: flex;
  flex-direction: column;
  margin: 8px;
}
.prop-node > span{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.node-attr > .btn-icon {
  font-size: 25px;
  cursor: pointer;
  margin-left: 10px;
}

.footer {
  padding: 8px;
  margin-top: 8px;
  border-top: 1px solid #0005;
  display: flex;
  justify-content: flex-end;
}

.footer > button {
  margin-left: 8px;
}

</style>
